import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import { _T } from 'appI18n';
import { useListSubheaderStyles } from "./styles";
import moment from 'moment';
function ExtraServiceIcon() {
    return React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fontSize: "6px", "aria-hidden": "true" },
        React.createElement("text", { x: "1", y: "14", letterSpacing: "-0.1", fill: "#fff" }, "SERVICE"));
}
export default function ExtraServiceDescription({ services }) {
    const subhClasses = useListSubheaderStyles();
    return React.createElement(List, { subheader: React.createElement(ListSubheader, { className: subhClasses.root, disableGutters: true }, _T.COMMON_EXTRA_SERVICES) }, services.map((x, i) => React.createElement(ListItem, { disableGutters: true, key: i },
        React.createElement(ListItemAvatar, null,
            React.createElement(Avatar, null,
                React.createElement(ExtraServiceIcon, null))),
        React.createElement(ListItemText, { primary: x.name, secondary: `${moment(x.beginDate).format("L")} (${moment(x.beginDate).format("dd")})` }))));
}
